import { sagas as officeInformationSagas } from './modules/officeInformation'

export default [...officeInformationSagas]
